// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.header {
  display: flex;
  align-items: start;
  justify-content: flex-start;
  flex-direction: column;
  padding: 10px 0px;
  background: transparent;
  height: calc(100% - 80px);
  padding: 0 0 30px;
  text-transform: uppercase;
}
.header .icon_wrapper ion-icon {
  height: 10px;
  width: 10px;
  rotate: 180deg;
  transition: rotate 0.5s;
  margin-left: 10px;
}
.header .icon_wrapper ion-icon.isOpen {
  rotate: 0deg;
}

.title {
  cursor: pointer;
  position: relative;
  margin: 15px 0 15px;
  text-transform: uppercase;
  font-family: Montserrat, sans-serif;
  font-size: 22px;
  font-weight: 600;
  line-height: 25px;
  text-align: left;
  color: #fff;
}

.name {
  font-family: Montserrat, sans-serif;
  font-size: 14px;
  line-height: 15px;
  letter-spacing: 0.01em;
  color: #fff;
  text-align: left;
  text-transform: uppercase;
  padding: 15px 0px;
}

p {
  padding: 15px 0px;
  text-align: left;
  font-family: Montserrat, sans-serif;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.01em;
  text-transform: uppercase;
  color: #fff;
}

div {
  position: relative;
  transition: max-height linear 0.3s;
}
.active {
  max-height: -moz-fit-content;
  max-height: fit-content;
  overflow: auto;
  width: 100%;
  padding-top: 10px;
}

.inactive {
  max-height: 0;
  overflow: hidden;
}

.nutrition-name {
  font-size: 14px;
  text-align: left;
  color: #fff;
  padding-left: 20px;
}

.nutrition-value {
  text-align: right;
  color: #fff;
  text-transform: uppercase;
  font-size: 14px;
  padding-right: 20px;
}

.border-top {
  border-top: 1px solid var(--color-black);
}

.allergens_title {
  font-family: Montserrat, sans-serif;
  font-size: 16px;
  color: #fff;
  text-transform: uppercase;
}

ul {
  margin: 0px;
  padding: 0px 30px;
}
ul li {
  font-size: 14px;
  text-align: left;
  color: #fff;
  text-transform: uppercase;
  padding: 6px 0px;
}

.padding-top {
  padding-top: 15px;
}

.button {
  width: 100%;
}
.button .close {
  background: #ebdfda;
  text-align: center;
  border-radius: 26px;
  cursor: pointer;
}
.button .close:hover {
  background: #f2dbd9;
}
.button .close p {
  text-align: center;
  font-size: 16px;
  padding: 10px;
  font-family: Montserrat, sans-serif;
  color: #fff;
  text-transform: uppercase;
}

.cross-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 25px;
  height: 25px;
  z-index: 99;
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.cross-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.cross-icon:hover {
  background: #f2dbd9;
}

ion-button {
  --border-width: 1px;
  --border-color: var(--accent-color);
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/app/components/allergens-info-modal/allergens-info-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EAEA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;AAAF;AAOA;EACE,aAAA;EACA,kBAAA;EACA,2BAAA;EACA,sBAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;EACA,iBAAA;EACA,yBAAA;AALF;AAQK;EACG,YAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;AANR;AAOQ;EACG,YAAA;AALX;;AAWA;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EAEA,yBAAA;EAEA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EAEA,WAAA;AAXF;;AAcA;EACE,mCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;EAEA,gBAAA;EACA,yBAAA;EAEA,iBAAA;AAbF;;AAgBA;EACE,iBAAA;EACA,gBAAA;EACA,mCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,WAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,kCAAA;AAdF;AAuBA;EACE,4BAAA;EAAA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;AArBF;;AAwBA;EACE,aAAA;EACA,gBAAA;AArBF;;AAuBA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EAGA,kBAAA;AAtBF;;AAwBA;EACE,iBAAA;EACA,WAAA;EAEA,yBAAA;EAEA,eAAA;EACA,mBAAA;AAvBF;;AAyBA;EACE,wCAAA;AAtBF;;AAwBA;EACE,mCAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;AArBF;;AAwBA;EACE,WAAA;EAEA,iBAAA;AAtBF;AAuBE;EACG,eAAA;EACA,gBAAA;EACD,WAAA;EAEA,yBAAA;EACC,gBAAA;AAtBL;;AAyBA;EACE,iBAAA;AAtBF;;AAwBA;EACE,WAAA;AArBF;AAsBE;EAEE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AArBJ;AAsBI;EAEE,mBAAA;AArBN;AAuBI;EACE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mCAAA;EACA,WAAA;EACA,yBAAA;AArBN;;AA0BA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EAEA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAxBF;AAyBE;EACI,WAAA;EACA,YAAA;EACA,WAAA;AAvBN;AAyBE;EACI,mBAAA;AAvBN;;AA2BA;EACE,mBAAA;EACA,mCAAA;EACA,gBAAA;AAxBF","sourcesContent":[".container {\n  width: 100%;\n\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  // background: #EAEAEB;\n  &.activated {\n     // background: white;\n  }\n}\n\n.header {\n  display: flex;\n  align-items: start;\n  justify-content: flex-start;\n  flex-direction: column;\n  padding: 10px 0px;\n  background: transparent;\n  height: calc(100% - 80px);\n  padding: 0 0 30px;\n  text-transform: uppercase;\n\n  .icon_wrapper {\n     ion-icon {\n        height: 10px;\n        width: 10px;\n        rotate: 180deg;\n        transition: rotate 0.5s;\n        margin-left: 10px;\n        &.isOpen{\n           rotate: 0deg;\n        }\n     }\n  }\n}\n\n.title {\n  cursor: pointer;\n  position: relative;\n  margin: 15px 0 15px;\n\n  text-transform: uppercase;\n\n  font-family: Montserrat, sans-serif;\n  font-size: 22px;\n  font-weight: 600;\n  line-height: 25px;\n  text-align: left;\n\n  color: #fff;\n}\n\n.name {\n  font-family:Montserrat, sans-serif;\n  font-size: 14px;\n  line-height: 15px;\n  letter-spacing: 0.01em;\n  color: #fff;\n\n  text-align: left;\n  text-transform: uppercase;\n\n  padding: 15px 0px;\n}\n\np {\n  padding: 15px 0px;\n  text-align: left;\n  font-family: Montserrat, sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.01em;\n  text-transform: uppercase;\n\n  color: #fff;\n}\n\ndiv {\n  position: relative;\n  transition: max-height linear 0.3s;\n\n  ion-button {\n\n\n\n  }\n}\n\n.active {\n  max-height: fit-content;\n  overflow: auto;\n  width: 100%;\n  padding-top: 10px;\n}\n\n.inactive {\n  max-height: 0;\n  overflow: hidden;\n}\n.nutrition-name {\n  font-size: 14px;\n  text-align: left;\n  color: #fff;\n\n\n  padding-left: 20px;\n}\n.nutrition-value {\n  text-align: right;\n  color: #fff;\n\n  text-transform: uppercase;\n\n  font-size: 14px;\n  padding-right: 20px;\n}\n.border-top {\n  border-top: 1px solid var(--color-black);\n}\n.allergens_title {\n  font-family: Montserrat, sans-serif;\n  font-size: 16px;\n  color: #fff;\n  text-transform: uppercase;\n\n}\nul {\n  margin: 0px;\n  // list-style-type: none;\n  padding: 0px 30px;\n  li {\n     font-size: 14px;\n     text-align: left;\n    color: #fff;\n\n    text-transform: uppercase;\n     padding: 6px 0px;\n  }\n}\n.padding-top {\n  padding-top: 15px;\n}\n.button {\n  width: 100%;\n  .close {\n\n    background: #ebdfda;\n    text-align: center;\n    border-radius: 26px;\n    cursor: pointer;\n    &:hover {\n\n      background: #f2dbd9;\n    }\n    p {\n      text-align: center;\n      font-size: 16px;\n      padding: 10px;\n      font-family: Montserrat, sans-serif;\n      color: #fff;\n      text-transform: uppercase;\n\n    }\n  }\n}\n.cross-icon {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  width: 25px;\n  height: 25px;\n  z-index: 99;\n\n  margin: 0px;\n  background: var(--color-white-accent);\n  width: 35px;\n  height: 35px;\n  padding: 0px;\n  z-index: 99;\n  ion-icon {\n      width: 100%;\n      height: 100%;\n      margin: 0px;\n  }\n  &:hover {\n      background: #f2dbd9;\n  }\n}\n\nion-button {\n  --border-width: 1px;\n  --border-color: var(--accent-color);\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
